import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Il materiale è digitale o fisico?',
    a: "Il Mega-Pack è completamente digitale e potrai scaricarlo immediatamente dopo l'acquisto. Nessuna attesa per la spedizione."
  }, {
    q: 'Per quanto tempo avrò accesso?',
    a: 'Avrai accesso permanente a tutti i materiali. Potrai scaricarli, salvarli sui tuoi dispositivi e stamparli tutte le volte che vorrai.'
  }, {
    q: 'Serve esperienza con lo yoga?',
    a: 'No. Tutte le attività sono spiegate passo dopo passo e sono pensate specificamente anche per principianti assoluti.'
  }, {
    q: 'Posso utilizzare i materiali in classe?',
    a: "Assolutamente sì. Il Mega-Pack include una sezione dedicata specificamente all'uso in classe e a scuola, perfetta per gli insegnanti."
  }, {
    q: "Come ricevo i materiali dopo l'acquisto?",
    a: "Subito dopo il pagamento sicuro, verrai reindirizzato alla pagina di download e riceverai anche un'email con il link per scaricare tutti i materiali."
  }, {
    q: 'I materiali sono adatti a tutte le età?',
    a: "Sì, le attività sono pensate principalmente per bambini dai 3 ai 12 anni e possono essere adattate facilmente in base all'età e alle capacità."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-50">
          Domande frequenti
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-53">
                <span className="font-semibold text-gray-900 text-lg pr-4" data-id="element-54">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>
              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="p-5 bg-white text-gray-700 border-t border-gray-100" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}